<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Información del Usuario">
          <b-table 
              small 
              responsive="sm" 
              :items="usuarioDatos" 
              :fields="campos">
            <template slot="valor" slot-scope="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="editar">
            <i class="fa fa-edit"></i>Editar Datos del Usuario</b-dropdown-item>
          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'usuario/getField',
  mutationType: 'usuario/updateField',
});

export default {
  name: 'Usuario',
  data: () => {
    return {
      id: 0,
      campos: [
        {key: 'campo'},
        {key: 'valor'},
      ],
      loaded: false,
      tableBusy: false,
    }
  },
  created() {
    this.id= this.$route.params.id
    this.tableBusy = true;
    this.loaded = true;

    this.$store.dispatch('usuario/getDatos', this.id)
      .then(response => {
        this.tableBusy = false;
        this.loaded = false;
      });
  },  
  computed: {
    ...mapFields([
      'usuarioDatos',
    ]),
  },  
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    editar() {
      this.$router.push({ name: 'UsuarioABM', 
                          params: { id: this.id }});
    },
  }
}
</script>
